@if (loading) {
  <div class="spinner-overlay" [class]="'spinner-overlay--' + align">
    <p-progressSpinner
      [style]="{width, height}"
      strokeWidth="2"
    ></p-progressSpinner>
  </div>
}
